<template>
  <div class="qualification-list-container">
    <!-- 列表页 -->
    <template v-if="showFlag">
      <!-- 页面头部 -->
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <svg class="icon" viewBox="0 0 24 24">
              <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"/>
            </svg>
          </div>
          <div class="header-text">
            <h1 class="page-title">资质管理</h1>
            <p class="page-description">资质信息的录入、管理与维护</p>
          </div>
          <div class="header-actions">
            <el-button 
              v-if="isAuth('qualification','新增')" 
              type="primary" 
              icon="el-icon-plus" 
              @click="addOrUpdateHandler()" 
              class="add-btn"
            >
              新增资质
            </el-button>
          </div>
        </div>
      </div>

      <!-- 搜索和筛选区域 -->
      <div class="filter-section">
        <el-card class="filter-card" shadow="never">
          <div class="filter-content">
            <el-form :inline="true" :model="searchForm" class="search-form">
              <div class="filter-row">
                <div class="filter-group">
                  <label class="filter-label">资质名称</label>
                  <div class="filter-input">
                    <el-input 
                      v-model="searchForm.name" 
                      placeholder="请输入资质名称" 
                      clearable
                      prefix-icon="el-icon-search"
                      class="search-input"
                    ></el-input>
                  </div>
                </div>
                
                <div class="filter-actions">
                  <el-button 
                    type="primary" 
                    icon="el-icon-search" 
                    @click="search()"
                    class="search-btn"
                  >
                    查询
                  </el-button>
                  <el-button 
                    icon="el-icon-refresh" 
                    @click="reset()"
                    class="reset-btn"
                  >
                    重置
                  </el-button>
                </div>
              </div>
            </el-form>
          </div>
        </el-card>
      </div>

      <!-- 操作栏 -->
      <div class="toolbar-section" v-if="dataListSelections.length > 0">
        <el-card class="toolbar-card" shadow="never">
          <div class="toolbar-content">
            <div class="selection-info">
              <i class="el-icon-info"></i>
              <span>已选择 <strong>{{ dataListSelections.length }}</strong> 项</span>
            </div>
            <div class="batch-actions">
              <el-button 
                v-if="isAuth('qualification','删除')" 
                type="danger" 
                icon="el-icon-delete" 
                @click="deleteHandler()"
                class="batch-delete-btn"
              >
                批量删除
              </el-button>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 数据表格 -->
      <div class="table-section">
        <el-card class="table-card" shadow="never">
          <el-table
            :data="dataList"
            border
            v-loading="dataListLoading"
            @selection-change="selectionChangeHandler"
            class="data-table"
            style="width: 100%;">
            <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
            <el-table-column prop="name" header-align="center" align="center" label="资质名称"></el-table-column>
            <el-table-column prop="image" header-align="center" align="center" label="资质图片">
              <template slot-scope="scope">
                <img v-if="scope.row.image" :src="getImageUrl(scope.row.image)" style="width: 50px; height: 50px; object-fit: cover;">
                <span v-else class="no-image">暂无图片</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" header-align="center" align="center" label="状态">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'">
                  {{ scope.row.status === '1' ? '正常' : '禁用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" header-align="center" align="center" label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createTime ? scope.row.createTime.substring(0, 10) : '' }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" header-align="center" align="center" width="200" label="操作">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-button 
                    v-if="isAuth('qualification','修改')" 
                    type="primary" 
                    size="mini" 
                    icon="el-icon-edit"
                    @click="addOrUpdateHandler(scope.row.id)"
                    class="action-btn edit-btn"
                  >
                    编辑
                  </el-button>
                  <el-button 
                    @click="toggleStatus(scope.row.id)"
                    :type="scope.row.status === '1' ? 'warning' : 'success'"
                    size="mini" 
                    :icon="scope.row.status === '1' ? 'el-icon-close' : 'el-icon-check'"
                    class="action-btn status-btn"
                  >
                    {{ scope.row.status === '1' ? '禁用' : '启用' }}
                  </el-button>
                  <el-button 
                    v-if="isAuth('qualification','删除')" 
                    type="danger" 
                    size="mini" 
                    icon="el-icon-delete"
                    @click="deleteHandler(scope.row.id)"
                    class="action-btn delete-btn"
                  >
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          
          <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination-content">
          </el-pagination>
        </el-card>
      </div>
    </template>
    
    <!-- 添加/修改 -->
    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
export default {
  data () {
    return {
      searchForm: {
        name: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false,
      isAuthReady: false,
    }
  },
  components: {
    AddOrUpdate
  },
  activated () {
    this.getDataList()
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    contentStyleChange() {
      this.contentPageStyleChange()
    },
    
    contentPageStyleChange(){
      let arr = []
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
      if(this.searchForm.name){
        params.name = this.searchForm.name
      }
      this.$http({
        url: "qualification/page",
        method: "get",
        params: params
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandler (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandler (id) {
      this.showFlag = false
      this.addOrUpdateFlag = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandler (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "qualification/delete",
          method: "post",
          data: ids
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    // 搜索
    search() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 重置
    reset() {
      this.searchForm = {
        name: ''
      }
      this.pageIndex = 1
      this.getDataList()
    },
    // 切换状态
    toggleStatus(id) {
      this.$confirm(`确定要${this.dataList.find(item => item.id === id).status === '1' ? '禁用' : '启用'}此资质吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `qualification/toggleStatus/${id}`,
          method: "get"
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    
    // 获取图片完整URL
    getImageUrl(imagePath) {
      if (!imagePath) return '';
      if (imagePath.startsWith('http')) return imagePath;
      return this.$base.url + imagePath;
    }
  }
}
</script>

<style lang="scss" scoped>
.qualification-list-container {
  background: #f8fafc;
  min-height: 100vh;
  padding: 24px;
}

// 页面头部
.page-header {
  margin-bottom: 24px;
  
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    padding: 20px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .header-icon {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;

      .icon {
        width: 24px;
        height: 24px;
        fill: white;
      }
    }

    .header-text {
      flex: 1;

      .page-title {
        font-size: 24px;
        font-weight: 600;
        color: #1e293b;
        margin: 0 0 8px 0;
        line-height: 1.2;
      }

      .page-description {
        font-size: 14px;
        color: #64748b;
        margin: 0;
        line-height: 1.4;
      }
    }

    .header-actions {
      .add-btn {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        padding: 12px 24px;
        border-radius: 8px;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
        }
      }
    }
  }
}

// 搜索和筛选区域
.filter-section {
  margin-bottom: 24px;

  .filter-card {
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .filter-content {
      padding: 20px;

      .search-form {
        .filter-row {
          display: flex;
          align-items: center;
          gap: 24px;

          .filter-group {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .filter-label {
              font-size: 14px;
              font-weight: 500;
              color: #374151;
              margin: 0;
            }

            .filter-input {
              .search-input {
                width: 300px;
                border-radius: 6px;

                .el-input__inner {
                  border-radius: 6px;
                  border: 1px solid #d1d5db;
                  transition: all 0.2s ease;

                  &:focus {
                    border-color: #667eea;
                    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                  }
                }
              }
            }
          }

          .filter-actions {
            display: flex;
            gap: 12px;
            margin-left: auto;

            .search-btn {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              border: none;
              padding: 10px 20px;
              border-radius: 6px;
              font-weight: 500;
              transition: all 0.2s ease;

              &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
              }
            }

            .reset-btn {
              background: #f8fafc;
              border: 1px solid #e2e8f0;
              color: #64748b;
              padding: 10px 20px;
              border-radius: 6px;
              font-weight: 500;
              transition: all 0.2s ease;

              &:hover {
                background: #f1f5f9;
                border-color: #cbd5e1;
                color: #475569;
              }
            }
          }
        }
      }
    }
  }
}

// 操作栏
.toolbar-section {
  margin-bottom: 24px;

  .toolbar-card {
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .toolbar-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;

      .selection-info {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #64748b;
        font-size: 14px;

        i {
          color: #3b82f6;
        }

        strong {
          color: #1e293b;
        }
      }

      .batch-actions {
        .batch-delete-btn {
          background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          font-weight: 500;
          transition: all 0.2s ease;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
          }
        }
      }
    }
  }
}

// 数据表格
.table-section {
  .table-card {
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .data-table {
      border-radius: 8px;
      overflow: hidden;

      .el-table__header {
        background: #f8fafc;

        th {
          background: #f8fafc;
          color: #374151;
          font-weight: 600;
          border-bottom: 1px solid #e2e8f0;
        }
      }

      .el-table__body {
        tr {
          transition: all 0.2s ease;

          &:hover {
            background: #f8fafc;
          }

          td {
            border-bottom: 1px solid #f1f5f9;
            padding: 16px 0;
          }
        }
      }

      // 状态标签样式
      .el-tag {
        border-radius: 4px;
        font-weight: 500;
        padding: 4px 8px;
      }

      // 图片显示样式
      img {
        border-radius: 4px;
        border: 1px solid #e2e8f0;
        transition: all 0.2s ease;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }

      .no-image {
        color: #9ca3af;
        font-size: 12px;
        font-style: italic;
      }

      // 操作按钮样式
      .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        flex-wrap: wrap;

        .action-btn {
          border-radius: 4px;
          font-weight: 500;
          transition: all 0.2s ease;
          padding: 6px 12px;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          }

          &.edit-btn {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            border: none;
            color: white;

            &:hover {
              background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
            }
          }

          &.status-btn {
            border: none;
            color: white;

            &.el-button--warning {
              background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);

              &:hover {
                background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
              }
            }

            &.el-button--success {
              background: linear-gradient(135deg, #10b981 0%, #059669 100%);

              &:hover {
                background: linear-gradient(135deg, #059669 0%, #047857 100%);
              }
            }
          }

          &.delete-btn {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none;
            color: white;

            &:hover {
              background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            }
          }
        }
      }
    }

    .pagination-content {
      padding: 20px;
      text-align: right;
      border-top: 1px solid #f1f5f9;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .qualification-list-container {
    padding: 16px;
  }

  .filter-section {
    .filter-card {
      .filter-content {
        .search-form {
          .filter-row {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;

            .filter-actions {
              margin-left: 0;
              justify-content: center;
            }
          }
        }
      }
    }
  }

  .page-header {
    .header-content {
      flex-direction: column;
      gap: 16px;
      text-align: center;

      .header-text {
        text-align: center;
      }
    }
  }
}
</style> 